import { Moment } from "moment-timezone";

export const formatDate = (date: Moment | undefined) => {
  return date ? date.format("MMM DD, YYYY - hh:mm a") : "";
}
